import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import SMCPageLoading from '../core/pageComponents/SMCPageLoading';
import SMCLabel from '../Simple/SMCLabel';
import SMCButton from '../Simple/SMCButton';
import ColumnLayout from '../Layouts/ColumnLayout';

function EditorBody({
    height,
    width,
    EditorPageElement,
    editorPageData,
    isPageLoadFailed,
    isPageLoaded,
    reloadData
}) {
    const classes = useStyles();

    const body = useMemo(() => {
        if (!isPageLoaded) {
            return <SMCPageLoading />
        }
        if (isPageLoadFailed) {
            return (
                <div className="centerContent" style={{ height: '100%' }}>
                    <ColumnLayout spacing="4px" center>
                        <SMCLabel bold>Error loading data</SMCLabel>
                        {
                            reloadData ? (
                                <SMCButton onClick={reloadData} ignoreDisabledContext>Try again</SMCButton>
                            ) : (
                                <SMCLabel bold>Please try again</SMCLabel>
                            )
                        }
                    </ColumnLayout>
                </div>
            );
        }
        else {
            return (
                <>
                <div className={classes.headerDiv} />
                <EditorPageElement {...editorPageData} />
                </>
            );
        }
    }, [editorPageData, isPageLoadFailed, isPageLoaded, reloadData, classes]);

    return (
        <div className={classes.root} style={{ width: width, height: height }}>
            <div className={classes.pageView}>
                { body }
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        verticalAlign: "top",
        minWidth: 550
    },
    headerDiv: {
        width: '100%',
        height: 11
    },
    pageView: {
		borderBottom: '0px',
		borderRight: '0px',
		width: '100%',
		height: '100%',
        minWidth: '550px',
        background: '#FFF',
        color: '#384C6E',
        fontSize: '10pt',
        border: '1px solid #CFCFD2',
        overflow: 'auto',
        scrollbarBaseColor: '#F7F7F7'
    }
})

EditorBody.propTypes = {
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    EditorPageElement: PropTypes.any,
    editorPageData: PropTypes.object,
    isPageLoaded: PropTypes.bool,
    isPageLoadFailed: PropTypes.bool,
    reloadData: PropTypes.func
}

export default EditorBody;